export default __webpack_public_path__ + "static/media/6.1fb25c0f.jpeg";